import { APP_SETTINGS, DOWNLOAD_FILE_TYPES } from "../settings";
import Notification from "../components/Notification";
import LoadingSpin from "../components/LoadingSpin";
import { DownloadIconWithAnimation, DeleteIcon } from "../components/Icons";
import { findItemByValue } from "../utils";
import useDownloadData from "./useDownloadData";
import useForm from "../hooks/useForm";

const DownloadLayerItem = ({ gpServiceInfo, fileType, clearNotification }) => {
  const { GP } = APP_SETTINGS.GIS_SERVER;
  const { getSelectedQueryLayer } = useForm();
  const { error, downloadLink } = useDownloadData({
    gpServiceInfo,
    fileType,
    GPService: GP,
    getSelectedQueryLayer,
  });

  return (
    <Notification type={error ? "error" : "warning"}>
      <div className="flex">
        {downloadLink ? (
          <>
            <DownloadIconWithAnimation />
            <a href={`${downloadLink}`} className="w-full underline">
              Ready to Download the{" "}
              {findItemByValue(DOWNLOAD_FILE_TYPES, fileType).name} file.
            </a>
            <button onClick={clearNotification}>
              <DeleteIcon />
            </button>
          </>
        ) : (
          <>
            {error ? (
              "Something went wrong please try again."
            ) : (
              <>
                <LoadingSpin />
                <div className="w-full">{`Generating ${
                  findItemByValue(DOWNLOAD_FILE_TYPES, fileType).name
                } download link..`}</div>
              </>
            )}
          </>
        )}
      </div>
    </Notification>
  );
};

export default DownloadLayerItem;
